module.exports = __webpack_public_path__ + "img/person.846a1c7d.png";